// ButtonsManager ---------------------------------------------
function ButtonsManager(clrs) {

	//Import classes
	var Container = include('createjs.Container'),
		FishButton = include('WGBH.FishButton'),
		KeyboardControl = include('WGBH.KeyboardControl');
		EventDispatcher = include('springroll.EventDispatcher');
	
	// parameters
	this.clrs = clrs;
	this.active_btn = '';
	
	// objects
	this.view = new Container();
	this.ev_disp = new EventDispatcher();
	
	// used to initialize the button manager
	this.init = function() {
		this.left_bt = new FishButton(this.clrs[0], app.config.GAME.BUTTONS.answer1.x, app.config.GAME.BUTTONS.answers.y);
		this.center_bt = new FishButton(this.clrs[1], app.config.GAME.BUTTONS.answer2.x, app.config.GAME.BUTTONS.answers.y);
		this.right_bt = new FishButton(this.clrs[2], app.config.GAME.BUTTONS.answer3.x, app.config.GAME.BUTTONS.answers.y);
		this.view.addChild(this.left_bt.view);
		this.view.addChild(this.center_bt.view);
		this.view.addChild(this.right_bt.view);
		// set up arrow controls
		this.key_controls = new KeyboardControl();
		this.key_controls.ev_disp.on('KEY_PRESSED', this.keyPressed);
		// set listeners for focus
		this.left_bt.bt.btn.addEventListener('focus', this.focusOnLeft, false);
		this.center_bt.bt.btn.addEventListener('focus', this.focusOnCenter, false);
		this.right_bt.bt.btn.addEventListener('focus', this.focusOnRight, false);
	};
	
	// used to mark focus on the left button
	this.focusOnLeft = function() {
		this.active_btn = 'left';
	};
	
	// used to mark focus on the center button
	this.focusOnCenter = function() {
		this.active_btn = 'center';
	};
	
	// used to mark focus on the right button
	this.focusOnRight = function() {
		this.active_btn = 'right';
	};
	
	// used to start the button display
	this.startButtonDisplay = function() {
		this.left_bt.startAnimation(app.config.GAME.BUTTONS.answers.delay);
		app.voPlayer.play(['intro2-a'], this.showCenterButton);	
	};
	
	// used to animate the display of the second button
	this.showCenterButton = function() {
		this.center_bt.startAnimation(0);
		app.voPlayer.play(['tinypause','intro2-b'], this.showRightButton);	
	};
	
	// used to animate the display of the third button
	this.showRightButton = function() {
		this.right_bt.startAnimation(0);
		app.voPlayer.play(['tinypause','intro2-c'], this.enableButtons);	
	};
	
	// used to enable all of the buttons
	this.enableButtons = function() {
		this.left_bt.bt.enableButton();
		this.center_bt.bt.enableButton();
		this.right_bt.bt.enableButton();
		this.left_bt.bt.ev_disp.on('BUTTON_DOWN', this.answerSelected);
		this.center_bt.bt.ev_disp.on('BUTTON_DOWN', this.answerSelected);
		this.right_bt.bt.ev_disp.on('BUTTON_DOWN', this.answerSelected);
		// set arrow keys
		this.key_controls.allowControls = true;
	};
	
	// used to disable all of the buttons
	this.disableButtons = function() {
		this.left_bt.bt.disableButton();
		this.center_bt.bt.disableButton();
		this.right_bt.bt.disableButton();
		this.left_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		this.center_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		this.right_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		// set arrow keys
		this.key_controls.allowControls = false;
	};
	
	// used to select an answer
	this.answerSelected = function(ev) {
		this.disableButtons();
		this.answer = ev.id;
		this.answer = this.answer.substring(0, (this.answer.indexOf('_')));
		this.triggerMessageEvent();	
	};
		
	// used for navigation by keyboard
	this.keyPressed = function(ev){
		switch(ev.type) {
		case 'RIGHT':
			switch(this.active_btn) {
			case '':
				this.left_bt.bt.btn.focus();		
				break;
			case 'left':
				this.center_bt.bt.btn.focus();			
				break;
			case 'center':
				this.right_bt.bt.btn.focus();			
				break;
			default:
				break;
			}
			break;
		case 'LEFT':
			switch(this.active_btn) {
			case '':
				this.left_bt.bt.btn.focus();		
				break;
			case 'right':
				this.center_bt.bt.btn.focus();			
				break;
			case 'center':
				this.left_bt.bt.btn.focus();			
				break;
			default:
				break;
			}
			break;
		case 'TAB':
			break;
		}
	};	
	
	
	// used to clear the object
	this.clearObject = function() {
		this.left_bt.bt.btn.removeEventListener('focus', this.focusOnLeft, false);
		this.center_bt.bt.btn.removeEventListener('focus', this.focusOnCenter, false);
		this.right_bt.bt.btn.removeEventListener('focus', this.focusOnRight, false);
		while(this.view.numChildren > 0) {
			this.view.removeChildAt(0);
		}
		// clear the buttons
		this.left_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		this.center_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		this.right_bt.bt.ev_disp.off('BUTTON_DOWN', this.answerSelected);
		this.left_bt.clearObject();
		this.center_bt.clearObject();
		this.right_bt.clearObject();
		this.left_bt = null;
		this.center_bt = null;
		this.right_bt = null;
		this.view = null;	
	};
		
	// used to trigger various events
	this.triggerMessageEvent = function() {
		this.ev_disp.trigger('ANSWER_SELECTED', {clr:this.answer});	
	};
	
	// set up function bindinds
	this.showCenterButton = this.showCenterButton.bind(this);
	this.showRightButton = this.showRightButton.bind(this);
	this.enableButtons = this.enableButtons.bind(this);
	this.answerSelected = this.answerSelected.bind(this);
	this.keyPressed = this.keyPressed.bind(this);
	this.focusOnLeft = this.focusOnLeft.bind(this);
	this.focusOnCenter = this.focusOnCenter.bind(this);
	this.focusOnRight = this.focusOnRight.bind(this);
	
	this.init();

}

namespace('WGBH').ButtonsManager = ButtonsManager;
